import Vue from "vue";
import { VTooltip } from "v-tooltip";
import "./lowercase";
// Here we should import directives that we can directly implement into every vue components
//import './lowercase'

//temporary @todo
Vue.directive("tooltip", VTooltip);
